import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heading, SubHeading, Body } from '../Constants/Fonts';
import CommonButton from './CommonButton';
import './CommonComingSoon.css';

function CommonComingSoon({
    title = 'AI Governance',
    subtitle = 'A single place to govern every AI model, agent, and use case across your organization — discover where AI is used, assess its risk, enforce responsible-use policies, and stay audit-ready as frameworks like the EU AI Act and NIST AI RMF evolve.',
    eta,
    monogram = 'FS',
    brandName = 'Foresee Security',
    highlights = [
        'Inventory & risk-rate every AI model and use case',
        'Policy guardrails aligned to the EU AI Act & NIST AI RMF',
        'Continuous monitoring with audit-ready evidence',
    ],
    primaryText = 'Back to dashboard',
    onPrimary,
}) {
    const navigate = useNavigate();

    const handlePrimary = () => {
        if (onPrimary) return onPrimary();
        if (window.history.length > 1) return navigate(-1);
        navigate('/product-dashboard');
    };

    return (
        <div className="ccs theme-light">
            {/* Decorative page backdrop — purely visual */}
            <div className="ccs__backdrop" aria-hidden="true">
                <span className="ccs__glow ccs__glow--one" />
                <span className="ccs__glow ccs__glow--two" />
                <span className="ccs__grid" />
            </div>

            <div className="ccs__card cmn_elevated_card">

                {/* ---- Right: content panel ---- */}
                <div className="ccs__content">
                    <div className="ccs__badge">
                        <span className="ccs__pulse" aria-hidden="true" />
                        <Body as="span" variant={2} weight="semibold" color="var(--color-primary)">Coming soon</Body>
                    </div>

                    <Heading as="h1" variant={2} className="ccs__title" color="var(--color-text-primary)" style={{ margin: '14px 0 0' }}>
                        {title} is on the way
                    </Heading>

                    {eta && (
                        <div className="ccs__eta">
                            <svg className="ccs__eta_icon" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                                <circle cx="8" cy="8" r="6.3" stroke="currentColor" strokeWidth="1.3" />
                                <path d="M8 5v3l2 1.3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <Body as="span" variant={2} color="var(--color-text-secondary)">Expected availability</Body>
                            <Body as="span" variant={2} weight="semibold" color="var(--color-text-primary)">{eta}</Body>
                        </div>
                    )}

                    <Body className="ccs__subtitle" variant={1} color="var(--color-text-secondary)" style={{ margin: '14px 0 0' }}>
                        {subtitle}
                    </Body>

                    {highlights && highlights.length > 0 && (
                        <ul className="ccs__list">
                            {highlights.map((h, i) => (
                                <li className="ccs__list_item" key={i}>
                                    <span className="ccs__tick" aria-hidden="true">
                                        <svg viewBox="0 0 16 16" fill="none">
                                            <path d="M3.5 8.5l3 3 6-7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                    <Body as="span" variant={1} color="var(--color-text-primary)">{h}</Body>
                                </li>
                            ))}
                        </ul>
                    )}

                    <div className="ccs__actions">
                        <CommonButton text={primaryText} onClick={handlePrimary} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CommonComingSoon;
